module.exports = __webpack_public_path__ + "static/img/bg_parksummer.a728bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_parksummer.png
// module id = KXTW
// module chunks = 0